import React, { useEffect, useState } from "react"
import { Alert, CircularProgress, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import Vista from "../../components/Vista"
import Multifile from "../../components/Multifile"
import Servo from "../../services/servo"

export default function Documentos({ match }) {
  const [carro, setCarro] = useState(null)
  const [error, setError] = useState("")
  useEffect(() => {
    let active = true
    Servo.get(`carros?idCarro=${encodeURIComponent(match.params.id)}&expand=archivos`)
      .then(res => {
        if (!active) return
        const unit = res?.cuerpo?.resultado?.[0]
        if (!unit) setError("No se encontró la unidad o no tienes acceso.")
        else setCarro(unit)
      }).catch(() => { if (active) setError("No se pudieron consultar los documentos.") })
    return () => { active = false }
  }, [match.params.id])
  return <Vista><div style={{ padding: 24 }}>
    <Link to="/carros">Volver a carros</Link>
    {error ? <Alert severity="error">{error}</Alert> : !carro ? <CircularProgress /> : <>
      <Typography variant="h5">Documentos y bitácora · {carro.economico} · {carro.placas}</Typography>
      <Multifile files={carro.archivos || []} readOnly />
    </>}
  </div></Vista>
}
